import { render, staticRenderFns } from "./DistributeModal.vue?vue&type=template&id=38138367"
import script from "./DistributeModal.vue?vue&type=script&lang=js"
export * from "./DistributeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports